var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueCheckmarkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3361f6",
    d: "M48 0c26.51 0 48 21.49 48 48S74.51 96 48 96 0 74.51 0 48 21.49 0 48 0zM26.764 49.277c.644-3.734 4.906-5.813 8.269-3.79.305.182.596.398.867.646l.026.025c1.509 1.446 3.2 2.951 4.876 4.443l1.438 1.291 17.063-17.898c1.019-1.067 1.764-1.757 3.293-2.101 5.235-1.155 8.916 5.244 5.206 9.155L46.536 63.366c-2.003 2.137-5.583 2.332-7.736.291-1.234-1.146-2.576-2.312-3.933-3.489-2.35-2.042-4.747-4.125-6.701-6.187-1.173-1.172-1.679-3.091-1.402-4.704z"
  })));
}
export default __webpack_public_path__ + "media/icons/blue-checkmark-icon-2a55fd3b.svg";
export { SvgBlueCheckmarkIcon as ReactComponent };